import { BaseEntity } from "yt-ng-framework";

export class DokumentStavka extends BaseEntity{
    constructor(){
        super();
    }

    DokumentID: number = null;
    ValutaID: number = null;
    IznosValute: number = 0;
    IznosPoKursuTrans: number = 0;
    IznosPoSrednjemKursu: number = 0;
    PocetnoStanje: number = 0;
    KupovinaOdBanke: number = 0;
    UlazSaDeviznogRacuna: number = 0;
    InterniUlaz: number = 0;
    InterniUlazPlatUsl: number = 0;
    Zamena: number = 0;
    InterniIzlaz: number = 0;
    IzlazNaDevizniRacun: number = 0;
    ProdajaBanci: number = 0;
    ProdajaBanciObavezi: number = 0;
    InterniIzlazEvraPlatUsl: number = 0;
    ProdBanciPoKursu: number = 0;
    ProdBanciPoSredKursu: number = 0;

    Deserialize(input:any){
        this.ID=input.ID;
        this.DokumentID = this.DokumentID;
        this.ValutaID=input.ValutaID;
        this.IznosValute=input.IznosValute;
        this.IznosPoKursuTrans=input.IznosPoKursuTrans;
        this.IznosPoSrednjemKursu = input.IznosPoSrednjemKursu;
        this.PocetnoStanje = input.PocetnoStanje;
        this.KupovinaOdBanke = input.KupovinaOdBanke;
        this.UlazSaDeviznogRacuna = input.UlazSaDeviznogRacuna;
        this.InterniUlaz = input.InterniUlaz;
        this.InterniUlazPlatUsl = input.InterniUlazPlatUsl;
        this.Zamena = input.Zamena;
        this.InterniIzlaz = input.InterniIzlaz;
        this.IzlazNaDevizniRacun = input.IzlazNaDevizniRacun;
        this.ProdajaBanci = input.ProdajaBanci;
        this.ProdajaBanciObavezi = input.ProdajaBanciObavezi;
        this.InterniIzlazEvraPlatUsl = input.InterniIzlazEvraPlatUsl;
        this.ProdBanciPoKursu = input.ProdBanciPoKursu;
        this.ProdBanciPoSredKursu = input.ProdBanciPoSredKursu;

        return this;
    }
    Serialize(input:DokumentStavka){
        let dokumentStavka: DokumentStavka = new DokumentStavka();
        dokumentStavka.ID = input.ID;
        dokumentStavka.DokumentID = input.DokumentID;
        dokumentStavka.ValutaID = input.ValutaID
        dokumentStavka.IznosValute = input.IznosValute ? input.IznosValute : 0;
        dokumentStavka.IznosPoKursuTrans = input.IznosPoKursuTrans ? input.IznosPoKursuTrans : 0;
        dokumentStavka.IznosPoSrednjemKursu = input.IznosPoSrednjemKursu ? input.IznosPoSrednjemKursu : 0;
        dokumentStavka.PocetnoStanje = input.PocetnoStanje ? input.PocetnoStanje : 0;
        dokumentStavka.KupovinaOdBanke = input.KupovinaOdBanke ? input.KupovinaOdBanke : 0;
        dokumentStavka.UlazSaDeviznogRacuna = input.UlazSaDeviznogRacuna ? input.UlazSaDeviznogRacuna : 0;
        dokumentStavka.InterniUlaz = input.InterniUlaz ? input.InterniUlaz : 0;
        dokumentStavka.InterniUlazPlatUsl = input.InterniUlazPlatUsl ? input.InterniUlazPlatUsl : 0;
        dokumentStavka.Zamena = input.Zamena ? input.Zamena : 0;
        dokumentStavka.InterniIzlaz = input.InterniIzlaz ? input.InterniIzlaz : 0;
        dokumentStavka.IzlazNaDevizniRacun = input.IzlazNaDevizniRacun ? input.IzlazNaDevizniRacun : 0;
        dokumentStavka.ProdajaBanci = input.ProdajaBanci ? input.ProdajaBanci : 0;
        dokumentStavka.ProdajaBanciObavezi = input.ProdajaBanciObavezi ? input.ProdajaBanciObavezi : 0;
        dokumentStavka.InterniIzlazEvraPlatUsl = input.InterniIzlazEvraPlatUsl ? input.InterniIzlazEvraPlatUsl : 0;
        dokumentStavka.ProdBanciPoKursu = input.ProdBanciPoKursu ? input.ProdBanciPoKursu : 0;
        dokumentStavka.ProdBanciPoSredKursu = input.ProdBanciPoSredKursu ? input.ProdBanciPoSredKursu : 0;

        return dokumentStavka;
    }
}